









































import Vue from "vue";
import Component from "vue-class-component";
import { SocialMedia } from "../../services/social-media/entities/social-media.interface";
import { Prop } from "vue-property-decorator";

@Component
export default class DeleteSocialMediaDialog extends Vue {
  @Prop() socialMedia!: SocialMedia;
  @Prop() dialogDelete!: boolean;

  loadingDelete = false;

  private cancelDelete(): void {
    this.$emit("cancelDelete");
  }

  private removeSocialMedia(): void {
    this.loadingDelete = true;
    this.$store
      .dispatch("socialMedia/deleteSocialMedia", this.socialMedia.socialMediaID)
      .then((response: boolean) => {
        if (response) {
          this.$emit("openSnackbarSuccessDelete");
        } else {
          this.$emit("openSnackbarErrorDelete");
        }

        this.loadingDelete = false;
        this.$emit("cancelDelete");
        this.$store.dispatch("socialMedia/getSocialMedia");
      });
  }
}
